import React, { useRef, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { fetchdata, viewdata } from './../reduxactions/organizationactions/OrgFeedbacksActions';
import { useNavigate } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import { Panel } from 'primereact/panel';
import { GFNButton } from '../ui';
import { Tag } from 'primereact/tag';

const OrganizationFeedbacks = () => {
    const uid = window.sessionStorage.getItem('uid');
    const [globalFilter, setGlobalFilter] = useState('')


    const dispatch = useDispatch();

    useEffectOnce(() => {
        const fetchDataAsync = async () => {
            try {
                await dispatch(fetchdata(uid) as any);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchDataAsync();
    }, [dispatch]);

    const navigate = useNavigate();
    //To open view
    const orgaddfeed = (rowData: any) => {
        const url = `/addfeedbacks`;
        console.log('Row ID:', rowData.userid
        );
        // Use navigate to navigate to the URL
        navigate(url);
    };


    const data = useSelector((state: RootState) => state.orgfeed.data);
    const dataview = useSelector((state: RootState) => state.orgfeed.dataview);

    const [acceptfield, setfield] = useState(false);
    const cancelfield = () => {
        setfield(false);
    }
    //To view data 
    //data from table 
    const viewupload = (rowData: any) => {
        assignData.current = { Feedback_id: rowData.Feedback_id }
        setfield(true);
        fetchDataAsyncdialog();

    };
    const assignData = useRef({ Feedback_id: '' })
    const fetchDataAsyncdialog = async () => {
        try {
            const { Feedback_id } = assignData.current;
            console.log("Feedback_id", Feedback_id)
            await dispatch(viewdata(uid, Feedback_id) as any);
        } catch (error) {
            console.error('Error deleting data:', error);
        }
    };
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/org-feedbacks.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };

    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        <section className="app-page-header">
                            <div>
                                <h1 className="app-page-title">Feedback</h1>
                            </div>
                            <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                                Help for this Page
                                <i className="pi pi-question-circle"></i>
                            </a>
                        </section>
                        <Panel>
                            <div className="grid">
                                <div className="col-12">
                                    <div className="card card-primary">

                                        <div className="card flex flex-wrap justify-content-end">

                                            {/* <Button label="Add Feedback" data-testid="add-feedback-btn" severity="info" onClick={() => orgaddfeed(true)} /> */}
                                            <GFNButton label="Add Feedback" data-testid="add-feedback-btn" buttonType="primary" onClick={() => orgaddfeed(true)} />
                                        </div>
                                        <div className="card flex flex-wrap justify-content-end my-2">
                                            <span className="p-input-icon-left">
                                                <i className="pi pi-search ml-2" />

                                                <InputText
                                                    className="app-search-input"
                                                    value={globalFilter}
                                                    onChange={(e) => setGlobalFilter(e.target.value)}
                                                    placeholder="Global Search"
                                                />
                                            </span>
                                        </div>
                                        <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                            <Column field="date" sortable header="Date"></Column>
                                            <Column field="firstName" sortable header="Name"></Column>
                                            <Column field="description" sortable header="Description "></Column>

                                            <Column header="Operation" body={(rowData, { rowIndex }) => (
                                                <>
                                                    {/* <Button icon="pi/// pi-eye" data-testid={`view-btn-${rowIndex}`} rounded outlined tooltip="View" onClick={() => viewupload(rowData)} style={{ backgroundColor: 'white', color: 'blue' }} /> */}
                                                    <GFNButton icon="pi pi-eye" data-testid={`view-btn-${rowIndex}`} rounded tooltip="View" onClick={() => viewupload(rowData)} buttonType="primary" />
                                                </>
                                            )} />
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        {/*Assign DIALOG */}

                        <Dialog
                            header="Request Details"
                            visible={acceptfield}
                            onHide={cancelfield}
                            style={{ width: "35vw" }}
                            breakpoints={{ "960px": "60vw", "640px": "95vw" }}
                            className="border-round-3xl"
                        >

                            {dataview.map((response: any, index: number) => (

                                <div key={index} className="p-3">

                                    {/* Profile Section */}
                                    <div className="flex align-items-center mb-4">

                                        <div
                                            className="flex align-items-center justify-content-center border-circle shadow-2"
                                            style={{
                                                width: "70px",
                                                height: "70px",
                                                background: "#dbeafe"
                                            }}
                                        >
                                            <i
                                                className="pi pi-user text-3xl text-blue-500"
                                            ></i>
                                        </div>

                                        <div className="ml-3">
                                            <h2 className="m-0 text-900">
                                                {response.firstName}
                                            </h2>

                                            <p className="m-0 text-600">
                                                {response.usertype}
                                            </p>
                                        </div>

                                    </div>

                                    {/* Details Card */}
                                    <div
                                        className="border-1 border-200 border-round-2xl p-4 surface-50"
                                    >

                                        {/* Date */}
                                        <div className="flex justify-content-between align-items-center mb-4">
                                            <span className="font-semibold text-700">
                                                <i className="pi pi-calendar mr-2 text-blue-500"></i>
                                                Date
                                            </span>

                                            <span className="text-600">
                                                {response.date}
                                            </span>
                                        </div>

                                        {/* Name */}
                                        <div className="flex justify-content-between align-items-center mb-4">
                                            <span className="font-semibold text-700">
                                                <i className="pi pi-user mr-2 text-green-500"></i>
                                                Name
                                            </span>

                                            <span className="text-600">
                                                {response.firstName}
                                            </span>
                                        </div>

                                        {/* Type */}
                                        <div className="flex justify-content-between align-items-center mb-4">
                                            <span className="font-semibold text-700">
                                                <i className="pi pi-tag mr-2 text-orange-500"></i>
                                                Type
                                            </span>

                                            <Tag
                                                value={response.usertype}
                                                severity="info"
                                            />
                                        </div>

                                        {/* Description */}
                                        <div className="mb-2">
                                            <span className="font-semibold text-700 block mb-3">
                                                <i className="pi pi-file-edit mr-2 text-purple-500"></i>
                                                Description
                                            </span>

                                            <div
                                                className="p-3 border-round-xl surface-0 border-1 border-200 text-600"
                                                style={{
                                                    lineHeight: "1.7"
                                                }}
                                            >
                                                {response.description}
                                            </div>
                                        </div>

                                    </div>

                                    {/* Footer Button */}
                                    <div className="flex justify-content-end mt-4">

                                        <GFNButton
                                            label="Close"
                                            icon="pi pi-times"
                                            className="ml-2"
                                            data-testid="cancel-btn"
                                            buttonType="secondary"
                                            onClick={cancelfield}
                                        />

                                    </div>

                                </div>

                            ))}

                        </Dialog>
                    </div>
                </div>
            </div>
        </div>
    )

}
export default OrganizationFeedbacks